import { Stack, Typography } from "@mui/material";
import "../../App.css";
import SchoolLogo from "../../Assets/logoReport.png";
import SymbolLogo from "../../Assets/symbol.jpg";

export default function KingdomOfCambodia() {
     return (
          <Stack direction="row" width="100%">
               <Stack justifyContent="center" width="20%">
                    <img src={SchoolLogo} width="150px" alt="Logo" />
               </Stack>
               <Stack direction="column" width="75%">
                    <Stack width="80%" justifyContent="center" alignItems="center">
                         <Typography className="cam-title-kh">
                              ព្រះរាជាណាចក្រកម្ពុជា
                         </Typography>
                         <Typography className="cam-title-en">
                              Kingdom Of Cambodia
                         </Typography>
                         <Typography className="cam-title-kh">
                              ជាតិ សាសនា ព្រះមហាក្សត្រ
                         </Typography>
                         <Typography className="cam-title-en">Nation Region King</Typography>
                         <img src={SymbolLogo} alt="SymbolLogo" width="180px" />
                    </Stack>
               </Stack>
          </Stack>
     )
}
